import React from 'react';

import { flagStyles } from '../settings';

const SvgIO = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2496px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgIO;
